@if (clientConfig?.enabled && (availablePromptProfiles.length > 0 || loadingPrompts)) {
  <main>
    <mat-tab-group preserveContent class="full-responsive-height no-header-margin" [ngClass]="{'hide-tabs' : selectedTab === 0 || hideMatTabs}" [disablePagination]="true" [(selectedIndex)]="selectedTab"
                   (selectedTabChange)="onTabChange($event)">
      <!-- 0: Choose prompt Tab -->
      <mat-tab label="choose prompt">
        <ng-template mat-tab-label>
        <span matTooltip="Choose a different prompt" matTooltipShowDelay="500">
            <mat-icon fontIcon="try" class="material-icons tab-icon"></mat-icon> Choose prompt
          <span class="watermark-number">1</span>
        </span>
        </ng-template>
        <h2 class="heading-underline with-icon" (click)="slider.focus()">
          <mat-icon fontIcon="try" class="material-icons"></mat-icon>
          Choose prompt
        </h2>
        @if (promptSlides.length === 0) {
          <app-skeleton [style]="'ai-assist-prompt-tiles'" [count]="9" [grid]="true" [gridColumns]="3" [gap]="14"></app-skeleton>
        }
        <!-- TODO: To go in a carousel container/prompt component  -->
        <article id="prompt-container" class="slides" tabindex="0" #slider
                 (keydown.arrowLeft)="handlePrevious()" (keydown.arrowRight)="handleNext()">
          <!-- TODO: Key Tabbing to other slides, beyond the first 9 -->
          @for (prompts of promptSlides; track $index; let i = $index) {
            <ul id="{{ i }}"
                class="prompt-grid scrollable-container slide"
                [ngClass]="{ active: i === currentSlideId }" #slideArray>
              @for (prompt of prompts; track $index) {
                <li tabindex="0"
                    (click) = "sendPromptRequest(prompt)"
                    (keydown.space)="sendPromptRequest(prompt)" (keydown.enter)="sendPromptRequest(prompt)"
                    [matTooltipDisabled]="disableContainerTooltip" matTooltip="Run prompt: {{prompt.action}}" matTooltipShowDelay="500">
                  <div class="prompt-name truncate-3-lines">{{prompt.displayName}}</div>
                  <i class="prompt-entity-icon {{bullhornIconService.getIcon(prompt.entityType!) }}"
                     matTooltip="{{getEntityLabel(prompt.entityType!)}} entity" matTooltipShowDelay="500"
                     (mouseenter)="disableContainerTooltip = true" (mouseleave)="disableContainerTooltip = false"></i>
                  <mat-icon fontIcon="play_arrow" class="watermark-icon"></mat-icon>
                  <aside class="action-icons">
                  </aside>
                  <aside class="action-icons-bottom">
                    @if (prompt.canCustomize) {
                      <mat-icon fontIcon="tune" class="configure" tabindex="0" matTooltip="Configure prompt before running" matTooltipShowDelay="500"
                                (click)="configurePrompt(prompt, $event)" (keydown.space)="configurePrompt(prompt, $event)" (keydown.enter)="configurePrompt(prompt, $event)"
                                (mouseenter)="disableContainerTooltip = true" (mouseleave)="disableContainerTooltip = false"></mat-icon>
                    }
                  </aside>
                </li>
              }
            </ul>
          }
        </article>
        <footer [ngClass]="{'disabled' : availablePromptProfiles.length <= 9 || !promptSlides}"
                (click)="slider.focus()">
          <mat-icon fontIcon="arrow_back_ios" (click)="handlePrevious()"></mat-icon>
          <div class="slide-indicators">
            @for (prompts of promptSlides; track $index; let i = $index) {
              <span class="indicator"
                    [ngClass]="{ active: i === currentSlideId }" (click)="handleSlideIndicatorClick(i)"></span>
            }
          </div>
          <mat-icon fontIcon="arrow_forward_ios" class="material-icons-outlined" (click)="handleNext()"></mat-icon>
        </footer>
      </mat-tab>


      <!-- 1: Prompt Options Tab -->
      <mat-tab label="Configuration" [disabled]="!selectedPromptProfile?.canCustomize">
        <ng-template mat-tab-label>
        <span [matTooltip]="selectedPromptProfile?.canCustomize ? 'Amend prompt configuration' : 'This prompt is not configurable'" matTooltipShowDelay="500">
          <mat-icon fontIcon="tune"></mat-icon> Prompt options
          <span class="watermark-number">2</span>
        </span>
        </ng-template>
        @if (selectedPromptProfile) {
          <app-configure-prompt #configurePromptComponent
                                [promptProfile]="selectedPromptProfile"
                                [noteList]="notes"
                                [fileList]="files" [useFileData]="fileDataOnly"
                                [modelList]="aiModels"
                                [selectedModel]="selectedModel"
                                [promptOptions]="promptOptions"
                                [selected]="defaultSelected"
                                [cardContextEntity]="bullhornCardContext.cardEntityType"
                                [availableEntities]="additionalEntityData"
                                [entities]="entities"
                                (includeEntityData)="useFileData($event)"
                                (selectedFiles)="setSelectedFiles($event)"
                                (selectedNotes)="setSelectedNotes($event)"
                                (aiOptions)="sendPromptRequest(selectedPromptProfile, $event)"></app-configure-prompt>
        }
      </mat-tab>

      <!-- 2: Ai Result/Response Tab -->
      <mat-tab label="Result" [disabled]="!aiResponse">
        <ng-template mat-tab-label>
        <span [matTooltip]="hasRunYet ? 'View the result of your prompt' : 'Prompt has not yet been run'" matTooltipShowDelay="500">
          <mat-icon fontIcon="auto_awesome" class="tab-icon"></mat-icon> Result
          <span class="watermark-number">3</span>
        </span>
        </ng-template>
        @if (hasRunYet && !aiResponse) {
          <app-loading-particles [promptName]="selectedPromptProfile?.displayName!" [selectedModel]="selectedModel"></app-loading-particles>
        }
        @if (aiResponse) {
          <app-ai-result
            [aiResponse]="aiResponse" [aiTokenResponse]="aiTokenResponse" [entityData]="availableDataV7" [bullhornCardContext]="bullhornCardContext"
            [selectedPromptProfile]="selectedPromptProfile!" [tinyApiKey]="environment.tinyApiKey" [fieldNameToSaveTo]="selectedPromptProfile!.outputFieldName"
            [clientConfig]="clientConfig"
            [enableCopyButton]="enableCopyButton"
            [enableSaveAsNote]="enableSaveAsNote"
            (aiOptions)="sendPromptRequest(selectedPromptProfile!)" (editorViewEmit)="hideMatTabs = $event"></app-ai-result>
        }
      </mat-tab>
    </mat-tab-group>
  </main>
}
@if (availablePromptProfiles.length === 0 && !loadingPrompts) {
  <main>
    <h2 class="no-prompt-profiles">
      No prompts have been published for this entity.
      <br>
      Please ask your AI Assist Admin to add or publish prompts in the AI Assist Manager.
    </h2>
  </main>
}
<div id="version-number" [ngClass]="{'expand-version': expandVersion}" title="Double click to copy - {{environment.environmentIdentifier}} v{{appVersion}}"
     (dblclick)="copyToClipboard(environment.environmentIdentifier + ' v' + appVersion)">
  @if (environment.environmentIdentifier !== 'PROD') {
    ENV: {{ environment.environmentIdentifier }}
  }
  v{{ appVersion }}
</div>

